import i18n from '@/i18n';
import Swal from "sweetalert2";

/* Functions here is everything general */
import { PLATFORM } from '@/constants/enums';

export function removeCurrencyFormat(value) {
	return Number(value.replace(/,+/g, ''));
}

export function isNullOrEmpty(value) {
	return value == undefined || value == 'undefined' || value == null || value == '';
}

// eslint-disable-next-line no-unused-vars
export function apiPaginationAdapter({ current_page, last_page, prev_page_url, next_page_url, per_page, total, count }) {
	return {
		pageNumber: Number(current_page),
		pageSize: Number(per_page),
		lastPage: Number(last_page),
		tableRowsCounts: Number(count),
		total: Number(total),
	};
}

export function getClientSidePagination({ per_page, current_page, count }) {
	return {
		pageNumber: Number(current_page),
		pageSize: Number(per_page),
		tableRowsCounts: Number(count),
	};
}

export function getErrorMessage(error) {
	var errorMessage = i18n.t("message.unknownError");

	if (error?.alertMessage) {
		errorMessage = error.alertMessage;
	} else if (error?.response?.data?.alertMessage) {
		errorMessage = error.response.data.alertMessage;
	} else if (error?.message) {
		errorMessage = error.message;
	}

	return errorMessage;
}

export function getHostname() {
	return window.location.origin;
}

export function getPlatform() {
	let type = PLATFORM.DESKTOP;

	if (
		navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/webOS/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/iPad/is) ||
		navigator.userAgent.match(/iPod/i) ||
		navigator.userAgent.match(/BlackBerry/i) ||
		navigator.userAgent.match(/Windows Phone/i)
	) {
		type = PLATFORM.MOBILE;
	} else {
		type = PLATFORM.DESKTOP;
	}

	return type;
}

export function alertSuccessMessage(message) {
	const swalWithBootstrapButtons = Swal.mixin({
		customClass: {
			confirmButton: "btn btn-info",
		},
		buttonsStyling: false,
	});
	swalWithBootstrapButtons.fire(i18n.t('message.success'), message, 'success');
}

export function alertSuccessMessageWithReload(message) {
	const swalWithBootstrapButtons = Swal.mixin({
		customClass: {
			confirmButton: "btn btn-info",
		},
		buttonsStyling: false,
	});

	swalWithBootstrapButtons
		.fire({
			title: i18n.t('message.success'),
			text: message,
			icon: "success",
			confirmButtonText: "OK",
		})
		.then(result => {
			if (result.value) {
				location.reload();
			}
		});
}

export function alertErrorMessage(message, code) {
	Swal.fire(i18n.t('message.error'), message + ' (' + code + ')', 'error');
}

export function alertErrorMessageWithoutCode(message) {
	Swal.fire(i18n.t('message.error'), message, 'error');
}

export function alertSuccessMessageAndClose(message) {
	const swalWithBootstrapButtons = Swal.mixin({
		customClass: {
			confirmButton: "btn btn-info",
		},
		buttonsStyling: false,
	});

	swalWithBootstrapButtons
		.fire({
			title: i18n.t('message.success'),
			text: message,
			icon: "success",
			confirmButtonText: "OK",
		})
		.then(result => {
			if (result.value) {
				window.close();
			}
		});
}

export function appendIfNotNull(formData, key, value) {
	if (value !== null && value !== undefined) {
		formData.append(key, value);
	}
}

export function appendIfNotNullArray(formData, key, value) {
	if (Array.isArray(value)) {
		value.forEach((v, i) => {
			formData.append(`${key}[${i}]`, v);
		});
	} else if (value !== null && value !== undefined) {
		formData.append(key, value);
	}
	else {
		console.log('here');
		formData.append(key, []);
	}
}

export function getAddressComponent(components, type) {
	if (!components) return "N/A";
	const component = components.find((c) => Array.isArray(c.types) && c.types.includes(type));

	return component ? component.longText : "N/A";
}

export function cleanAddress(formattedAddress, addressComponents) {
	if (!formattedAddress) return "N/A";

	const state = this.getAddressComponent(addressComponents, "administrative_area_level_1");
	const city = this.getAddressComponent(addressComponents, "locality");
	const postcode = this.getAddressComponent(addressComponents, "postal_code");
	const country = this.getAddressComponent(addressComponents, "country");

	let cleanedAddress = formattedAddress;
	if (state !== "N/A") cleanedAddress = cleanedAddress.replace(state, "").trim();
	if (city !== "N/A") cleanedAddress = cleanedAddress.replace(city, "").trim();
	if (postcode !== "N/A") cleanedAddress = cleanedAddress.replace(postcode, "").trim();
	if (country !== "N/A") cleanedAddress = cleanedAddress.replace(country, "").trim();

	return cleanedAddress.replace(/,\s*,/g, ",").replace(/,\s*$/, "").trim(); // Clean up extra commas
}

export function extractAddressLines(addressComponents) {
	if (!Array.isArray(addressComponents)) return { address_1: "", address_2: "", address_3: "" };

	const extractBasedOnType = (type) => {
		if (type == "") {
			const untyped = addressComponents
				.filter((c) => !Array.isArray(c.types) || c.types.length === 0)
				.map((c) => c.longText || c.shortText || "")
				.filter(Boolean);

			return untyped.join(", ");
		}

		const components = addressComponents.find((c) => Array.isArray(c.types) && c.types.includes(type));
		return components ? components.longText || components.shortText || "" : "";
	};

	const primary = extractBasedOnType("");
	const streetNumber = extractBasedOnType("street_number");
	const premise = extractBasedOnType("premise");
	const subpremise = extractBasedOnType("subpremise");
	const route = extractBasedOnType("route");
	const poi = extractBasedOnType("point_of_interest");
	const sublocality1 = extractBasedOnType("sublocality_level_1") || extractBasedOnType("sublocality");
	const sublocality2 = extractBasedOnType("sublocality_level_2");
	const sublocality3 = extractBasedOnType("sublocality_level_3");

	const address_1 = [primary, streetNumber, premise, subpremise].filter(Boolean).join(", ");
	const address_2 = [route].filter(Boolean).join(", ");
	const address_3 = [poi, sublocality1, sublocality2, sublocality3].filter(Boolean).join(", ");

	return {
		address_1,
		address_2,
		address_3,
	};
}
